import React from 'react'
import { Container } from '@scentregroup/ui'
import pagesHoc from '../pages-hoc'
import containerStyle from '../../components/container.scss'
import withNationalHomepage from '../../containers/with-national-homepage'
import { promotionType } from '../../types'
import Promotion from '../../components/promotion'
import CategoriesSplash from './categories-splash'
import style from './index.scss'

const Home = ({ promotion }) => (
  <React.Fragment>
    <Container type="large" className={containerStyle.container}>
      <CategoriesSplash />
    </Container>
    <div className={style.promotion}>
      <Container type="large" className={containerStyle.container}>
        <Promotion {...promotion} />
      </Container>
    </div>
  </React.Fragment>
)
const getMetaData = () => ({
  title: 'Products | Browse Online and Shop at Westfield',
  description:
    'Westfield is the leading destination for shopping. Discover 1000s of products from popular retailers in fashion, beauty, home, electronics and more.',
})

Home.propTypes = {
  promotion: promotionType,
}

export default withNationalHomepage(pagesHoc(Home, getMetaData))
